import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "ripple-avatar"
};
import { computed } from 'vue';
export default {
  __name: 'RippleAvatar',
  props: {
    avatarUrl: {
      type: String,
      default: ''
    },
    duration: {
      type: Number,
      default: 4.8
    },
    ringCount: {
      type: Number,
      default: 3
    }
  },

  setup(__props) {
    const props = __props;
    const delay = computed(() => props.duration / props.ringCount);
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.ringCount, index => {
        return _openBlock(), _createElementBlock("span", {
          key: index,
          class: "ripple-ring",
          style: _normalizeStyle({
            animationDelay: `${(index - 1) * delay.value}s`,
            animationDuration: `${__props.duration}s`
          })
        }, null, 4);
      }), 128)), _createVNode(_component_el_image, {
        src: __props.avatarUrl,
        alt: "",
        class: "avatar-img",
        draggable: "false"
      }, null, 8, ["src"])]);
    };
  }

};